const WEEKS = 53

function intensityAt(weekIndex, dayIndex) {
  const n = (weekIndex * 17 + dayIndex * 31 + weekIndex * dayIndex * 3) % 13
  if (n < 5) return 0
  if (n < 8) return 1
  if (n < 11) return 2
  return 3
}

export function buildHeatColumns() {
  const cols = []
  for (let w = 0; w < WEEKS; w += 1) {
    const column = []
    for (let d = 0; d < 7; d += 1) {
      column.push(intensityAt(w, d))
    }
    cols.push(column)
  }
  return cols
}

export const HEATMAP_MONTH_LABELS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const HEATMAP_WEEKDAY_LABELS = ['', 'M', '', 'W', '', 'F', '']
